export default __webpack_public_path__ + "static/media/empEzy1.98d41502.jpg";